// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"88559ded","542":"f2e572b0","845":"4e734fba"}[chunkId] + ".chunk.js";
};